<template>
  <div class="navbar-container">
    <div class="navbar">
      <div class="navbar-content" :class="{'scrolled':scrolled}">
        <div class="hide-l shrink link" @click="toggleSidenav()" v-if="location">
          <font-awesome-icon v-if="!sidenavVisible" :icon="['fal', 'bars']" size="2x" fixed-width />
          <font-awesome-icon v-if="sidenavVisible" :icon="['fal', 'arrow-left']" size="2x" fixed-width />
        </div>
        <div class="logo">
          <logo :scrolled="scrolled"></logo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import logo from '@/components/logo'

export default {
  name: 'navbar',
  components: { logo },
  computed: {
    ...mapState(['location', 'sidenavVisible']),
    scrolled() {
      return this.yOffset > 10
    },
  },
  data: function () {
    return {
      compress: false,
      yOffset: 0,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.handleScroll()
  },
  methods: {
    toggleSidenav() {
      this.$store.dispatch('toggleSidenav')
      console.log(this.$store.state.sidenavVisible)
    },
    getScroll() {
      if (window.pageYOffset !== undefined) {
        return [pageXOffset, pageYOffset]
      } else {
        var r = document.documentElement
        var b = document.body
        var sx = r.scrollLeft || b.scrollLeft || 0
        var sy = r.scrollTop || b.scrollTop || 0
        return [sx, sy]
      }
    },
    handleScroll(event) {
      // console.log(event)
      // console.log(this.getScroll())
      if (window.pageYOffset !== undefined) {
        this.yOffset = pageYOffset
      } else {
        this.yOffset = document.documentElement.scrollTop || document.body.scrollTop || 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";
.navbar-container {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 5000;
  .navbar {
    position:relative;
    max-width: $max-width;
    margin: auto;
    .navbar-content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding: $spacing;

      @media (max-width: $media-s) {
        padding: $spacing / 2;
      }

      background-color: rgba(0,0,0,0);
      background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%,rgba(0,0,0,0) 100%);
      // background-color: $highlight-color;
      transition: background 1s ease-in;
      .logo {
        flex-grow: 1;
        text-align: center;
      }

      &.scrolled {
        background-color: #151515;
        // background: linear-gradient(to bottom, rgb(0,0,0) 70%,rgba(0,0,0,0) 100%);
        transition: background .3s ease-out;
      }
    }
  }
}
</style>
